import { useQuery } from '@tanstack/react-query';
import { trackingService } from '@/services/tracking.service';
import { retryUnlessSetupError, trackerKeys, TRACKER_LIVE_INTERVAL_MS } from './trackerQuery';

export function useTrackerStats(live: boolean, enabled = true) {
  return useQuery({
    queryKey: trackerKeys.stats,
    queryFn: () => trackingService.stats(),
    refetchInterval: live ? TRACKER_LIVE_INTERVAL_MS : false,
    retry: retryUnlessSetupError,
    enabled,
  });
}
